function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.292.652l6.708 7 6.709-7",
  stroke: "#EB0B19"
});

function SvgDownArrowRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE2IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjI5MTk5IDAuNjUyMTYxTDguMDAwMzMgNy42NTIxNkwxNC43MDg3IDAuNjUyMTYxIiBzdHJva2U9IiNFQjBCMTkiLz4KPC9zdmc+Cg==";
export { SvgDownArrowRed as ReactComponent };